import React, {useEffect} from 'react';
import PopUp from '../../../Shared/Popup/PopUp';
import AutoComplete from '../../../Shared/AutoCompleteInput/AutoCompleteInput';
import {Container, Row, Col} from 'reactstrap';
import {displaySupportedTV, openPopover, closePopover} from './SupportedTVSlice';
import {connect} from 'react-redux';

const supportedTV = (props) => {
  useEffect(() => {
    window.addEventListener('resize', updateHeight);
  }, [props.show]);

  const updateHeight = () => {
    const el = document.querySelector('.box-dialog');

    if (el != undefined && el != null) {
      if (window.innerHeight <= 350) {
        el.style.height = '305px';
      } else {
        el.style.height = 'inherit';
      }
    }
  };

  return (
    <div>
      {props.show ? (
        <div className='popup-container'>
          <PopUp showPopUp={props.show} onClose={() => props.displaySupportedTV(false)} id='popup-callback'>
            {/*<h1>בדיקת טלויזיה</h1>
             {autocompleteInput(props)} */}
            <div dangerouslySetInnerHTML={{__html: props.supportedTVText}}></div>
          </PopUp>
        </div>
      ) : null}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {show: state.supportedTV.show, togglePopover: state.supportedTV.togglePopover};
};

const mapDispatchToProps = {
  displaySupportedTV,
  openPopover,
  closePopover,
};

export default connect(mapStateToProps, mapDispatchToProps)(supportedTV);
